import {defineStore} from 'pinia'
import EmployeeChannelWorkflowGroupsFactory, {
  type EmployeeChannelWorkflowGroup
} from '@/common/services/Workflow/EmployeeChannelWorkflowGroupsFactory.ts'
import {$inj} from '@/common/decorators/depinject.ts'
import type {WorkspaceHistory} from '@/common/services/WorkspaceHistory/workspaceHistoryService.ts'

export const WorkflowGroupStore = defineStore('WorkspaceGroupStore', {
  state: () => ({
    workspaceGroup: {} as EmployeeChannelWorkflowGroup | null,
    activeWorkspaceUUID: null as string | null,
    workspaceHistory: null as Array<WorkspaceHistory> | null
  }),
  actions: {
    resetGroup(workspaceUUID: string) {
      this.activeWorkspaceUUID = workspaceUUID
      this.workspaceGroup = null
      this.workspaceHistory = null
    },
    setGroup(workflowGroupId: string, workspaceUUID: string) {
      const employeeChannelWorkflowGroupsFactory = $inj(
        EmployeeChannelWorkflowGroupsFactory
      )

      return employeeChannelWorkflowGroupsFactory
        .get(workflowGroupId)
        .then((response) => {
          if (this.activeWorkspaceUUID === workspaceUUID) {
            this.workspaceGroup = response.data.payload
          }
        })
    },
    setWorkspaceHistory(workspaceUUID: string, history: Array<WorkspaceHistory>) {
      if (this.activeWorkspaceUUID === workspaceUUID) {
        this.workspaceHistory = history
      }
    }
  }
})
